import React, { Component } from 'react';
import './App.css';
import firebase from './helper/firebase';
import validator from 'email-validator';
import { Link } from 'react-router-dom';

import {
	AppBar,
	Avatar,
	Button,
	Card,
	Drawer,
	Hidden,
	// Icon,
	IconButton,
	TextField,
	Toolbar,
	Typography
} from 'material-ui';
import Tabs, { Tab } from 'material-ui/Tabs';

import Dialog, {
	DialogActions,
	DialogContent,
	DialogTitle
} from 'material-ui/Dialog';

import MenuIcon from 'material-ui-icons/Menu';
import CloseIcon from 'material-ui-icons/Close';

import Nav from './components/Nav';
import ToolbarMenuIcon from './components/ToolbarMenuIcon';
import ToolbarMenuNotificationIcon from './components/ToolbarMenuNotificationIcon';
import Snack from './components/Snack';
import DemoAnimatedIcon from './components/DemoAnimatedIcon';

import { ReactGoogleAnalytics } from './helper/functions';
import { Accent, bgWhite, Primary, Title } from './helper/consts';

import Logo from './img/logo.png';
import BrandMark from './img/BrandMark.svg';

import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
// import purple from 'material-ui/colors/purple';
// import green from 'material-ui/colors/green';
const theme = createMuiTheme();
// const theme = createMuiTheme({
// palette: {
// primary: purple,
// secondary: green,
// },
// });

const style = {
	menuToolbar: {
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'row',
		alignItems: 'center',
		paddingLeft: '24px'
	},
	loggedInToolbar: {
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'row',
		alignItems: 'center',
		position: 'fixed',
		// width: '100%',
		backgroundColor: Primary,
		width: 'calc(100vw - 250px)',
		right: '0'
	},
	Toolbar: {
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'row',
		alignItems: 'center',
		position: 'fixed',
		width: '100%',
		backgroundColor: Primary,
		zIndex: 2
	},
	logoAvatar: {
		width: '33px',
		height: '33px',
		marginRight: '5px'
	},
	drawerIconAndPageTitle: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		width: 'calc(100% / 3)',
		justifyContent: 'flex-start'
	},
	title: {
		display: 'flex',
		alignItems: 'center',
		width: 'calc(100% / 3)',
		justifyContent: 'center',
		position: 'relative'
	},
	navTitle: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	menuList: {
		display: 'flex',
		height: 'calc(100vh - 64px)',
		marginTop: '64px',
		flexDirection: 'column',
		backgroundColor: bgWhite,
		width: '250px'
	},
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	},
	drawer: {
		bottom: '0',
		zIndex: 3
	},
	drawerBody: {
		zIndex: 3
	},
	unverified: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center'
	},
	rightToolbarIcons: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		width: 'calc(100% / 3)'
	},
	row: {
		display: 'flex',
		flexWrap: 'wrap',
		margin: '21px 0'
	},
	input: {
		minWidth: '160px',
		flexGrow: '1',
		margin: '10px'
	},
	forgot: {
		cursor: 'pointer'
	}
};

export default class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			menuOpen: false,
			admin: false,
			email: '',
			password: '',
			displayName: '',
			verificationEmailMessage: 'Please verify your email address.',
			value: this.props.location.state
				? this.props.location.state.tab
				: 'signIn'
		};
	}

	componentWillUnmount() {
		const ref = firebase.database().ref();
		ref.child(`userNotifications/${this.props.uid}`).off();
		ref.child(`users/${this.props.uid}/online`).off();
		ref.child(`users/${this.props.uid}`).off();
	}

	componentDidMount() {
		this.props.actions.setupAuthListener();
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		//if on offer page, with offer id, and logged out, then show login modal, else return null
		if (
			!!nextProps.location &&
			!!nextProps.location.pathname &&
			!!nextProps.location.pathname.startsWith('/Offer/') &&
			!!(nextProps.location.pathname.length > 15) &&
			!nextProps.authLoading &&
			!nextProps.loggedIn &&
			!prevState.loginModal
		) {
			return {
				loginModal: !prevState.loginModal
			};
		} else {
			return null;
		}
	}

	openMenu = () => this.setState({ menuOpen: true });

	handleMenuClose = () => this.setState({ menuOpen: false });

	sendVerificationEmail = () => {
		const actionCodeSettings = {
			url: window.location.href
		};
		firebase
			.auth()
			.currentUser.sendEmailVerification(actionCodeSettings)
			.then(() => {
				this.setState({
					verificationEmailMessage: 'Email Sent',
					verificationEmailSent: true
				});
				this.props.actions.setSnack(true, `Email Sent`);
			})
			.catch(error => this.props.actions.setSnack(true, `Error: ${error}`));
	};

	renderDrawerNav = () => {
		const html = [];
		const nav = (
			<Hidden key="lgNav" only={['lgUp']}>
				<Drawer
					style={style.drawer}
					type="temporary"
					open={this.state.menuOpen}
					onRequestClose={this.handleMenuClose}
					onClick={this.handleMenuClose}
				>
					<AppBar style={style.drawerBody} className="appBar" position="static">
						<Toolbar style={style.menuToolbar}>
							<div style={style.navTitle}>
								<IconButton
									disableRipple
									onClick={this.handleMenuClose}
									color="contrast"
									aria-label="Menu"
								>
									<CloseIcon />
								</IconButton>
								<Link to={'/'}>
									<Typography
										id="toolbar_brandmark"
										type="title"
										color="inherit"
									>
										{Title}
									</Typography>
								</Link>
							</div>
						</Toolbar>
					</AppBar>
					<Nav location={this.props.location} admin={this.props.admin} />
				</Drawer>
			</Hidden>
		);
		html.push(nav);
		return html;
	};

	renderStickyNav = () => {
		const html = [];
		const nav = (
			<Hidden key="mdNav" lgDown>
				<Drawer
					style={style.drawer}
					className="lgDrawer"
					type="permanent"
					open={true}
					elevation={16}
				>
					<AppBar
						style={style.drawerBody}
						id="stickyNavAppBar"
						className="appBar"
						position="static"
					>
						<Toolbar id="stickyNavToolbar" style={style.menuToolbar}>
							<div style={style.navTitle}>
								<Link to={'/'}>
									<IconButton disableRipple>
										<Avatar style={style.logoAvatar} src={Logo} alt={Title} />
									</IconButton>
								</Link>
								<Link to={'/'}>
									<Typography
										id="toolbar_brandmark"
										type="title"
										color="inherit"
									>
										{}
									</Typography>
								</Link>
							</div>
						</Toolbar>
					</AppBar>
					<Nav location={this.props.location} admin={this.props.admin} />
				</Drawer>
			</Hidden>
		);
		html.push(nav);
		return html;
	};

	renderToolbar = () => {
		const html = [];
		const bar = (
			<AppBar id="toolbar" key="toolbar" position="fixed">
				<Toolbar
					style={style.Toolbar}
					className={this.props.loggedIn ? 'loggedInToolbar' : null}
				>
					<div
						className={this.props.loggedIn ? 'loggedInToolbarLogoIcon' : null}
						style={style.drawerIconAndPageTitle}
					>
						{this.props.loggedIn ? (
							<IconButton
								disableRipple
								onClick={this.openMenu}
								color="contrast"
								aria-label="Menu"
							>
								<MenuIcon />
							</IconButton>
						) : (
							<Link to={'/'}>
								<Avatar style={style.logoAvatar} src={Logo} alt={Title} />
							</Link>
						)}
						{!this.props.authLoading &&
							this.props.loggedIn && (
								<Hidden xsDown>
									<Typography
										id="toolbar_brandmark"
										type="title"
										color="inherit"
									>
										{!!window.location.hash.split('/')[1] && (
											<span style={{ fontWeight: '300', whiteSpace: 'pre' }}>
												{}
											</span>
										)}
									</Typography>
								</Hidden>
							)}
					</div>
					<Link style={style.title} to={'/'}>
						<img
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center'
							}}
							src={BrandMark}
							alt={Title}
						/>
						<span id="beta">beta</span>
					</Link>
					<div style={style.rightToolbarIcons} className="auth">
						{this.props.notifications && (
							<ToolbarMenuNotificationIcon
								uid={this.props.uid}
								notifications={this.props.notifications}
							/>
						)}
						{this.props.authLoading ? (
							<Button disabled>Loading</Button>
						) : this.props.loggedIn ? (
							<ToolbarMenuIcon uid={this.props.uid} user={this.props.auth} />
						) : this.props.location.pathname !== '/Logout' &&
						this.props.location.pathname !== '/Join' ? (
							<Button
								disableRipple
								onClick={() => {
									this.setState({ loginModal: !this.state.loginModal });
								}}
								raised
							>
								Login
							</Button>
						) : null}
					</div>
				</Toolbar>
			</AppBar>
		);
		html.push(bar);
		return html;
	};

	renderLoginModal = () => {
		let html = [];
		let modal = (
			<Dialog
				key="loginModal"
				open={this.state.loginModal}
				onClose={this.handleClose}
				aria-labelledby="responsive-dialog-title"
			>
				<DialogTitle id="responsive-dialog-title">
					<AppBar position="static" color="default">
						<Tabs
							centered
							fullWidth
							value={this.state.value}
							onChange={this.handleTabChange}
							indicatorColor="primary"
							textColor="primary"
						>
							<Tab value="signUp" label="Sign Up" />
							<Tab value="signIn" label="Sign In" />
							<Tab value="help" label="Help" />
						</Tabs>
					</AppBar>
				</DialogTitle>
				<DialogContent>
					{this.state.value === 'signUp' && (
						<form noValidate autoComplete="off">
							<div style={style.row} className="row">
								<TextField
									style={style.input}
									fullWidth
									id="email"
									label="Email"
									placeholder="Email..."
									error={this.state.emailError}
									required
									value={this.state.email}
									onChange={this.handleChange('email')}
									margin="normal"
								/>
								<TextField
									style={style.input}
									fullWidth
									id="password"
									type="password"
									label="Password"
									placeholder="Password..."
									error={this.state.passwordError}
									required
									value={this.state.password}
									onChange={this.handleChange('password')}
									margin="normal"
								/>
							</div>
							<div style={style.row} className="row">
								<TextField
									fullWidth
									style={style.input}
									id="fullName"
									label="Full Name"
									placeholder="Full Name..."
									error={this.state.displayNameError}
									required
									value={this.state.displayName}
									onChange={this.handleChange('displayName')}
									margin="normal"
								/>
							</div>
						</form>
					)}
					{this.state.value === 'signIn' && (
						<form noValidate autoComplete="off">
							<div style={style.row} className="row">
								<TextField
									style={style.input}
									id="email"
									label="Email"
									placeholder="Email..."
									error={this.state.emailError}
									required
									value={this.state.email}
									onChange={this.handleChange('email')}
									margin="normal"
								/>
								<TextField
									style={style.input}
									id="password"
									type="password"
									label="Password"
									placeholder="Password..."
									error={this.state.passwordError}
									required
									value={this.state.password}
									onChange={this.handleChange('password')}
									margin="normal"
								/>
							</div>
						</form>
					)}
					{this.state.value === 'help' && (
						<form noValidate autoComplete="off">
							<div style={style.row} className="row">
								<TextField
									style={style.input}
									id="email"
									label="Email"
									placeholder="Email..."
									error={this.state.emailError}
									required
									value={this.state.email}
									onChange={this.handleChange('email')}
									margin="normal"
								/>
							</div>
						</form>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={this.closeLoginModal} color="primary">
						Cancel
					</Button>
					{this.state.value === 'signIn' && (
						<Typography
							style={style.forgot}
							className="cardActionsBtn"
							onClick={() => {
								this.setState({ value: 'help' });
							}}
						>
							Forgot?
						</Typography>
					)}
					{this.state.value === 'signUp' && (
						<Button
							className="cardActionsBtn"
							raised
							disabled={this.state.signing}
							color="primary"
							onClick={() => {
								this.validate('signUp');
							}}
						>
							{this.state.signing ? 'Signing Up' : 'Sign Up'}
						</Button>
					)}
					{this.state.value === 'signIn' && (
						<Button
							className="cardActionsBtn"
							raised
							disabled={this.state.signing}
							color="primary"
							onClick={() => {
								this.validate('signIn');
							}}
						>
							{this.state.signing ? 'Signing In' : 'Sign In'}
						</Button>
					)}
					{this.state.value === 'help' && (
						<Button
							className="cardActionsBtn"
							raised
							disabled={this.state.signing}
							color="primary"
							onClick={() => {
								this.validate('help');
							}}
						>
							Reset
						</Button>
					)}
				</DialogActions>
			</Dialog>
		);
		html.push(modal);
		return html;
	};

	closeLoginModal = () => this.setState({ loginModal: false, value: 'signIn' });

	validate = path => {
		this.setState({ signing: true });
		const { email, password, displayName } = this.state;
		if (email.length < 1 || this.state.emailError) {
			this.props.actions.setSnack(true, `Error, please complete all fields`);
			this.setState({
				signing: false,
				emailError: true
				// snackStatus:true,snackMessage:'Error, please complete all fields.'
			});
			return;
		}
		if ((path === 'signUp' || path === 'signIn') && password.length < 5) {
			this.props.actions.setSnack(true, `Error, please complete all fields`);
			this.setState({
				signing: false,
				passwordError: true
				// snackStatus:true,snackMessage:'Error, please complete all fields.'
			});
			return;
		}
		if (path === 'signUp' && displayName.length < 5) {
			this.props.actions.setSnack(true, `Error, please complete all fields`);
			this.setState({
				signing: false,
				displayNameError: true
				// snackStatus:true,snackMessage:'Error, please complete all fields.'
			});
			return;
		}
		if (path === 'signUp') {
			this.signUp();
		}
		if (path === 'signIn') {
			this.signIn();
		}
		if (path === 'help') {
			this.sendPasswordResetEmail();
		}
	};

	handleChange = name => event => {
		this.setState({
			[name]: event.target.value,
			emailError: false,
			passwordError: false,
			displayNameError: false
		});
		if (name === 'email') {
			let status = validator.validate(event.target.value);
			this.setState({ emailError: !status });
		}
	};

	handleTabChange = (event, value) => {
		this.setState({
			value,
			emailError: false,
			passwordError: false,
			displayNameError: false
		});
	};

	signUp = () => {
		const { email, password, displayName } = this.state;
		const body = {
			email,
			password,
			displayName: displayName
		};
		const options = {
			method: 'post',
			body: JSON.stringify(body)
		};
		const url = `https://us-central1-talent-7d36f.cloudfunctions.net/signUpNewUser`;
		fetch(url, options)
			.then(res => {
				// console.log(res);
				this.signIn();
				ReactGoogleAnalytics('Auth', 'SignUp', null, null, null);
			})
			.catch(err => {
				console.log(err);
				this.props.actions.setSnack(
					true,
					`Error: Please check your details and try again`
				);
				this.setState({
					signing: false,
					emailError: true,
					passwordError: true
					// snackStatus:true,snackMessage:'Error: Please check your details and try again.'
				});
			});
	};

	sendPasswordResetEmail = () => {
		const { email } = this.state;
		const actionCodeSettings = {
			url: window.location.href
		};
		firebase
			.auth()
			.sendPasswordResetEmail(email, actionCodeSettings)
			.then(() => {
				this.props.actions.setSnack(true, `Password Reset Email Sent`);
				this.setState({
					signing: false
					// snackStatus:true, snackMessage:'Password Reset Email Sent.'
				});
				ReactGoogleAnalytics('Auth', 'PasswordResetRequest', null, null, null);
			})
			.catch(error => {
				this.props.actions.setSnack(true, `Error: ${error}`);
				this.setState({
					signing: false
					// snackStatus:true, snackMessage:`Error: ${error}`
				});
			});
	};

	signIn = () => {
		const { email, password } = this.state;
		firebase
			.auth()
			.signInWithEmailAndPassword(email, password)
			.then(user => {
				this.setState({
					signing: false,
					loginModal: false,
					value: 'signIn',
					email: '',
					password: '',
					displayName: ''
				});
				ReactGoogleAnalytics('Auth', 'Login', null, null, null);
			})
			.catch(error => {
				console.log(error);
				this.props.actions.setSnack(true, `Error: ${error}`);
				this.setState({
					signing: false,
					emailError: true,
					passwordError: true
					// snackStatus:true,
					// snackMessage:`Error: ${error}`,
				});
			});
	};

	// renderChildren = children => {
	// 	if (!children) return;
	// 	return {
	// 		...children, // all the key/values in children
	// 		props: {
	// 			...children.props // all they key/values in children.props
	// 		}
	// 	};
	// };

	renderUnverified = () => {
		// return (
		// 	<AppBar style={style.unverified} position="static" color="accent">
		// 		<Typography>{this.state.verificationEmailMessage}</Typography>
		// 		<Button padding="dense" onClick={this.sendVerificationEmail}>
		// 			Verify
		// 		</Button>
		// 	</AppBar>
		// );
		return (
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					width: '100vw',
					height: '100vh',
					backgroundColor: Primary,
					zIndex: 5,
					position: 'absolute'
				}}
				className="verifyEmail"
			>
				<Card
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						flexDirection: 'column',
						padding: '50px'
					}}
					className="card"
				>
					<DemoAnimatedIcon icon="verified_user" />
					<Typography
						style={{
							colo: Primary,
							fontWeight: '500',
							fontSize: '1.2rem',
							padding: '15px',
							textAlign: 'center'
						}}
					>
						Verify your email address
					</Typography>
					<Typography
						style={{
							colo: Primary,
							textAlign: 'center',
							padding: '15px',
							lineHeight: '1.5rem',
							fontWeight: '300'
						}}
					>
						{this.props.auth.displayName}, to start using {Title}, we need to
						verify your email address ({this.props.auth.email})
					</Typography>
					<Button
						disabled={this.state.verificationEmailSent}
						raised={true}
						variant="raised"
						size="large"
						color="primary"
						fullWidth={true}
						onClick={this.sendVerificationEmail}
						style={{
							width: '100%',
							padding: '11px',
							color: 'white',
							backgroundColor: Accent
						}}
					>
						{this.state.verificationEmailSent
							? 'Verification email sent'
							: 'Click to Verify'}
					</Button>
				</Card>
			</div>
		);
	};

	// renderVerificationBar = () => {
	// return(
	// 	<AppBar style={style.unverified} position="static" color="accent">
	// 		<Typography>{this.state.verificationEmailMessage}</Typography>
	// 		<Button padding="dense" onClick={this.sendVerificationEmail}>
	// 			Verify
	// 		</Button>
	// 	</AppBar>
	// )
	// };

	render() {
		return (
			<MuiThemeProvider theme={theme}>
				<div id="app" className="App">
					{this.props.loggedIn &&
						this.props.emailVerified &&
						this.renderDrawerNav()}

					{this.props.loggedIn &&
						this.props.emailVerified &&
						this.renderStickyNav()}

					{this.renderToolbar()}

					{this.props.loggedIn &&
						!this.props.emailVerified &&
						this.renderUnverified()}

					{!this.props.loggedIn && this.renderLoginModal()}

					<Snack
						snackStatus={this.props.snackStatus}
						snackMessage={this.props.snackMessage}
						closeSnack={() => {
							this.props.actions.setSnack(false, '');
						}}
					/>
				</div>
			</MuiThemeProvider>
		);
	}
}
// {this.state.unverified && this.renderVerificationBar()}
// {this.props.loggedIn && this.renderMiniNav()}
// {this.props.children}



// WEBPACK FOOTER //
// ./src/App.js